<template>
  <div class="container">
    <div class="bgoverlay">
      <div class="bg" :style="{'background-image': `url(${require('@/assets/images/responsibilitybg.jpg')})`}"></div>
    </div>
    <!-- <div class="">
      <div class="line-row">
        <div class="item">
          <div class="ball" style="top: -15px"></div>
          <span class="year"></span>
        </div>
        <div class="item">
          <div class="ball"></div>
          <span class="year">2020</span>
        </div>
        <div class="item">
          <div class="ball"></div>
          <span class="year">2019</span>
        </div>
        <div class="item">
          <div class="ball"></div>
          <span class="year">2018</span>
        </div>
        <div class="item">
          <div class="ball"></div>
          <span class="year">2017</span>
        </div>
        <div class="item">
          <div class="ball"></div>
          <span class="year">2016</span>
        </div>
        <div class="item">
          <div class="ball"></div>
          <span class="year">2015</span>
        </div>
        <div class="item">
          <div class="ball"></div>
          <span class="year">2014</span>
        </div>
        <div class="item">
          <div class="ball"></div>
          <span class="year">2013</span>
        </div>
      </div>
    </div> -->
    <div class="inner-pannel">
      <div class="pannel-content">
        <div class="pannel-content-box maxwidth-lg">
          <!-- <div style="height:55px;"></div> -->
          <div class="content-page">
            <div class="ani animate__animated animate__fadeInUp flex">
              <div class="line-row">
                <div class="item">
                  <div class="ball ball-active" style="top: -15px"></div>
                  <span class="year"></span>
                </div>
                <div v-for="(item,index) in $t('responsibility')" :key="index" class="item">
                  <div :class="activeYear==item.year?'ball ball-active':'ball'" @click="changeYear(item,index)"></div>
                  <span :class="activeYear==item.year?'year active':'year'">{{item.year}}</span>
                </div>
              </div>
              <div class="content-box">
                <div>{{activeData.title}}</div>
                <div class="flex" style="margin-top:60px">
                  <img style="width: 164px;margin-right:30px;cursor:pointer;" :src="image[index]" @click="goTo">
                  <div>
                    <div class="active">{{activeData.title}}</div>
                    <div class="active">{{activeData.year}}</div>
                    <img style="width: 27px;margin-top:30px;cursor:pointer;" src="../../assets/images/file-pdf.svg" @click="goTo">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default ({
  created() {
    this.activeData = this.$t('responsibility')[0]
  },
  data() {
    return {
      activeYear: '2021',
      activeData: {},
      index: 0,
      image:[
        require('../../assets/images/2021.jpg'),
        require('../../assets/images/2020.jpg'),
        require('../../assets/images/2019.jpg'),
        require('../../assets/images/2018.jpg'),
        require('../../assets/images/2017.jpg'),
        require('../../assets/images/2016.png'),
        require('../../assets/images/2015.png'),
        require('../../assets/images/2014.png'),
        require('../../assets/images/2013.png')
      ]
    }
  },
  methods: {
    changeYear(item,index) {
      this.activeYear = item.year
      this.index = index
      this.activeData = item
    },
    goTo(){
      window.open(this.activeData.url,'_blank')
    }
  }
})
</script>

<style scoped>
  .inner-pannel{
    min-height: 100%;
    padding-bottom: 54px;
    position: static;
    /* position: relative; */
    /* position: absolute; */
    width: 100%;
  }
  .pannel-content::before{
    display: none;
  }
  .pannel-content .pannel-content-box::before{
    display: none;
  }
  .pannel-content .pannel-content-box{
    padding: 0;
    border-right: 0;
  }
  .inner-pannel{
    padding-bottom: 0;
  }
  .inner-pannel::after{
    display: none;
  }
  .inner-pannel .pannel-content{
    border-bottom: 0;
  }
  .title{
    color: #ed6d00;
    padding: 10px 0;
  }
  .line-row{
    /* top: 0; */
    /* position: absolute; */
    width: 55px;
    height: 100%;
    margin-left: 100px;
    margin-right: 100px;
    /* overflow-y: scroll; */
  }
  .item{
    position: relative;
    border-right: 1px solid #ffffff;
    height: 100px;
  }
  .ball{
    position: absolute;
    cursor:pointer;
    right: -12.5px;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: #ffffff;
  }
  .ball-active{
    background: #ed6d00;
  }
  .year{
    margin-top: 5px;
    color: #ffffff;
    display: inline-block;
    transform:rotate(-90deg);
  }
  .active{
    color: #ed6d00;
  }
  .content-box{
    padding-top: 55px;
  }
  .flex{
    display: flex;
  }
  @media screen and (max-width:768px) {
    .line-row{
      margin-left: 10px;
      margin-right: 30px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/responsibility/responsibility.vue